var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n    © "+_vm._s(new Date().getFullYear())+"\n    "),_c('b-link',{attrs:{"href":"https://www.aar.org"}},[_vm._v("\n        Association of American Railroads\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }